import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from './Container'
import OverlineChip from './OverlineChip'

interface PageBannerProps {
  overline?: string
  headline: string
  subtext?: string
}

export default function PageBanner({ overline, headline, subtext }: PageBannerProps) {
  return (
    <Box
      sx={{
        backgroundColor: '#0B2027',
        py: { xs: 6, md: 8 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container>
        {overline && <OverlineChip label={overline} variant="filled" />}
        <Typography
          variant="h2"
          sx={{
            color: '#F0F4F4',
            mb: subtext ? 2 : 0,
            fontSize: { xs: '1.75rem', md: '2.5rem' },
            letterSpacing: '-0.02em',
            fontWeight: 800,
          }}
        >
          {headline}
        </Typography>
        {subtext && (
          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255,255,255,0.88)',
              maxWidth: 700,
              fontSize: '1.05rem',
              lineHeight: 1.65,
            }}
          >
            {subtext}
          </Typography>
        )}
      </Container>
    </Box>
  )
}
